import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { PAGES_URL } from "../../shared/constants/constants";
import { LocalShipping, ReceiptLong } from "@mui/icons-material";

const Home = () => {
    const navigate = useNavigate();
    const cardTypes = [
        {
            title: "Delivery Challan",
            navLink: PAGES_URL.GRN_MGR,
            icon: <LocalShipping />
        },
        {
            title: "Invoice",
            navLink: PAGES_URL.INVOICE_MGR,
            icon: <ReceiptLong />
        }
    ]

  return (
    <Stack height={"100%"} width={"100%"} flexGrow={1} justifyContent="center" alignItems="center" sx={{ px: 3 }}>
      <Stack
        spacing={2}
        direction={{xs: "column",  md : "row"}}
        sx={{ width: "100%", maxWidth: {xs: 480, md: 720} }}
      >
        {
            cardTypes?.map((card)=>(
                <Button
                    key={card.title}
                    variant="contained"
                    startIcon={card.icon}
                    onClick={() => navigate(card.navLink)}
                    sx={{
                        width: "100%",
                        height: 56,
                        fontSize: 16,
                        fontWeight: 500,
                        textTransform: "none",
                        justifyContent: "flex-start",
                        px: 3,
                    }}
                >
                    {card.title}
                </Button>
            ))
        }
      </Stack>
    </Stack>
  );
};

export default Home;
